import{createContext}from'react';export const SelectContext=createContext({});